import { Keyboard, Mousewheel } from 'swiper';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import ContentFrame from 'ui/ContentFrame/ContentFrame';
import SectionTitle from 'ui/SectionTitle/SectionTitle';
import data from './data';
import './Roadmap.scss';
import RoadmapCard from './RoadmapCard';

const Roadmap: React.FC = () => {
  const swiperSettings: SwiperProps = {
    slidesPerView: 1,
    modules: [Keyboard, Mousewheel],
    keyboard: true,
    mousewheel: true,
    grabCursor: true,
    speed: 500
  };

  return (
    <div className="roadmap" id="roadmap">
      <div className="roadmap__container container">
        <ContentFrame title="Roadmap">
          <div className="roadmap__content">
            <div className="roadmap__desc">
              <SectionTitle className="roadmap__title">
                <span>Roadmap</span>
              </SectionTitle>
              <p className="roadmap__text">
                Get set play is equipped with all of the infrastructures you
                need for p2p streaming. As a haven for gamers of all types, it
                is also the first decentralized p2p streaming platform.
              </p>
            </div>
            <div className="roadmap__slider">
              <Swiper {...swiperSettings} className="roadmap__swiper">
                {data.map(item => (
                  <SwiperSlide className="roadmap__slide" key={item.id}>
                    <RoadmapCard {...item} />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </ContentFrame>
      </div>
    </div>
  );
};

export default Roadmap;
